import { includes } from 'lodash'

const allowedMimeTypes = [
    'video/mp4',
    'video/quicktime',
    'video/x-ms-wmv',
    'video/x-msvideo',
    'video/x-matroska',
    'video/webm',
    'video/x-flv',
    'video/mpeg',
    'video/3gpp',
    'video/avi',
    'audio/mpeg',
    'audio/mp4',
    'audio/aac',
    'audio/wav',
    'audio/flac',
    'audio/ogg',
    'audio/x-ms-wma',
    'audio/opus',
    'audio/x-m4a',
]

export const fileTypeValidator = (file: File) => {
    const isValid = allowedMimeTypes.includes(file.type)
    return isValid
}

export const fileSizeValidator = (file: File) => {
    if (includes(file.type, 'video')) {
        return file.size < 1610612736
    } else if (includes(file.type, 'audio')) {
        return file.size < 1073741824
    }
}
